export default class TraceableError extends Error {
  /**
   * Original error object.
   *
   * @var {any}
   * @private
   */
  private readonly error: any;


  constructor(message?: string, error?: any) {
    super(message);
    this.error = error;

    // Print error to console (= trace)
    if (error) {
      console.error(error);
    }
  }
}
